import { configuration } from "../api/client/SdsWebApiClient";
import { DEFAULT_CONFIG_ENC_TYPE } from "./configImageUrl";

export interface BuildSummaryPdfUrlOptions {
    accountId?: string | null;
    market?: string | null;
    language?: string | null;
    hidePrice?: boolean;
    strict?: boolean;
}

/**
 * Builds a GET URL for the stateless `get_summary_pdf` API (mirrors `get_config_image_and_mask`).
 * Use it directly as an `<a href>`/download target or hand the URL to the parent frame.
 * Regenerating the typed client adds `getSummaryPdfGet`; this builder is client-regen independent.
 */
export function buildSummaryPdfUrl(
    encodedConfig: string,
    options: BuildSummaryPdfUrlOptions = {},
    basePath: string = configuration.basePath
): string {
    const params = new URLSearchParams();
    params.set("enc_type", DEFAULT_CONFIG_ENC_TYPE);
    params.set("encoded_config", encodedConfig);
    if (options.accountId) {
        params.set("account_id", options.accountId);
    }
    if (options.market) {
        params.set("market", options.market);
    }
    if (options.language) {
        params.set("language", options.language);
    }
    if (options.hidePrice !== undefined) {
        params.set("hide_price", String(options.hidePrice));
    }
    if (options.strict !== undefined) {
        params.set("strict", String(options.strict));
    }

    const root = basePath.replace(/\/+$/, "");
    return `${root}/api/get_summary_pdf?${params.toString()}`;
}
